import { withDefaultProps } from '@aspectus/vue-utils';
import SelectWidget from './SelectWidget';

export default withDefaultProps({ multiple: true })(SelectWidget);
